export const bulidFilterWorkReportRequest = ({ filters, paginationData }) => {
  const filtersWorkReport = {
    equipo: filters?.equipo
      ? {
          id: filters?.equipo.id,
          nombre: filters?.equipo.nombre
        }
      : null,
    servicios: filters?.idsServicios
      ? filters.idsServicios.map((servicio) => ({
          id: servicio.id,
          nombre: servicio.nombre
        }))
      : [],
    proveedores: filters.idsProveedores
      ? filters.idsProveedores.map((proveedor) => ({
          id: proveedor.id,
          nombre: proveedor.nombre
        }))
      : [],
    tipoEvento: filters.evento
      ? {
          id: filters?.evento.id,
          nombre: filters?.evento.nombre
        }
      : null,
    tipoUbicacionEnum: filters?.tipoUbicacionEnum
      ? {
          id: filters?.tipoUbicacionEnum.id,
          nombre: filters?.tipoUbicacionEnum.nombre
        }
      : null,
    ubicacion: filters?.ubicacion
      ? {
          value: filters.ubicacion.id,
          label: filters.ubicacion.nombre,
          ...filters.ubicacion
        }
      : null,
    unidadNegocio: filters?.unidadesNegocioIds
      ? filters?.unidadesNegocioIds.map((unidad) => ({
          id: unidad.id,
          nombre: unidad.nombre
        }))
      : [],
    operacionesIds: filters.operacionesIds
      ? filters.operacionesIds.map((operacion) => ({
          id: operacion.id,
          nombre: operacion.nombre
        }))
      : null,
    contratos: filters?.idsContratos?.length
      ? filters?.idsContratos.map((contrato) => ({ id: contrato.id, nombre: contrato.nombre }))
      : [],
    numeroSolicitud: filters?.numeroSolicitud?.length ? filters?.numeroSolicitud : null,
    pagination: {
      pageNumber: paginationData.pageNumber,
      pageSize: paginationData.pageSize
    },
    agrupaPorUbicacion: paginationData.agrupaPorUbicacion
  };

  return {
    filters: filtersWorkReport
  };
};

const mapFilterArray = (filterArray, key) =>
  filterArray?.length ? filterArray.map((item) => item[key]) : [];

const mapFilterId = (filter) => (filter ? filter.id : null);

export const buildFilterServiceRequest = (
  filters = null,
  paginationData = null,
  gridTab = null
) => {
  const filtersAfterSDS = {
    numeroSolicitudServicio: mapFilterArray(filters.numeroSolicitud, 'nombre'),
    ubicaciones: mapFilterArray(filters?.ubicacion, 'nombre'),
    tipoUbicacionEnum: mapFilterId(filters.tipoUbicacionEnum),
    fechaDesde: filters.fechaDesde || null,
    fechaHasta: filters.fechaHasta || null,
    servicioIds: mapFilterArray(filters?.idsServicios, 'id'),
    contratoIds: mapFilterArray(filters?.idsContratos, 'id'),
    proveedorIds: mapFilterArray(filters?.idsProveedores, 'id'),
    unidadesNegocioIds: mapFilterArray(filters?.unidadesNegocioIds, 'id'),
    operacionesIds: mapFilterArray(filters?.operacionesIds, 'id'),
    estadosEnums: mapFilterArray(filters?.estadosEnums, 'id'),
    equiposDeTorre: mapFilterArray(filters.equipo, 'id'),
    idUsuarioCreador: mapFilterId(filters.idUsuarioCreador),
    paginacion: paginationData,
    grillaAgrupadaEnum: gridTab,
    idPrioridad: mapFilterId(filters.idPrioridad),
    eventoIds: mapFilterArray(filters?.idEvento, 'id')
  };

  return {
    filtersAfterSDS
  };
};
